import React from "react";
import InputLabel from "../Inputs/Layout/InputLabel";
import InputContainer from "../Inputs/Layout/InputContainer";
import Markdown from "ae-base/Base/Markdown";

import { useResources } from "@aetonix/hooks";

export default function OutputMarkdown(props){
	const { localize, localizeFrom } = useResources();
	const schema = props.schema;
	const data = props.data;

	const valueLocalization = schema.value_localization || schema.valueLocalization;
	let text = data;

	if(valueLocalization){
		const localizeArgs = typeof data === "object" ? data : {
			"_": "" + data
		};
		text = localizeFrom(valueLocalization, ".", localizeArgs);
	} else if (schema.value_description) {
		text = localize(schema.value_description) || schema.value_description;
	}

	return (
		<InputContainer style={props.style}>
			<InputLabel schema={schema} title={props.title} contrast={props.contrast} />
			<Markdown contrast={props.contrast} noPdfFullScreen={props.noPdfFullScreen}>
				{text}
			</Markdown>
		</InputContainer>
	);
}